import { Component, EventEmitter, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-challenge-type-selection",
  templateUrl: "./challenge-type-selection.component.html",
  styleUrls: ["./challenge-type-selection.component.css"],
})
export class ChallengeTypeSelectionComponent implements OnInit {
  @Output() challengeTypeData = new EventEmitter<any>();
  constructor() {}

  typeOfChallenges = [
    {
      displayName: "Milestone Based",
      description:
        "A milestone-based challenge is a progressive system where users complete tasks to advance through increasing difficulty levels.",
      value: "MILESTONE_BASED_CHALLENGE",
    },
    // {
    //   displayName: "Streak",
    //   description:
    //     "A streak is a consecutive series of completed actions or achievements, encouraging consistency and engagement.",
    //   value: "STREAK",
    // },
  ];
  selectedChallenge = "MILESTONE_BASED_CHALLENGE";
  videoUrl: string = 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4';

  ngOnInit(): void {}

  selectType(value){
    this.selectedChallenge = value;
  }

  selectChallengeType(value){
    this.challengeTypeData.emit(value);
  }
}
